<div class="container">
  @if (isLoading) {
  <aw-spinner [fullScreen]="true"></aw-spinner>
  }
  <aw-toast></aw-toast>
  <aw-divider
    [inset]="false"
    [middleInset]="false"
    [title]="'Employee Management'"
    [altColor]="false"
  >
  </aw-divider>

  <div class="table-form-container" [ngClass]="container_theme()">
    <div>
      <aw-search
        [(ngModel)]="searchInputValue"
        (ngModelChange)="onSearchInput(searchInputValue)"
        [placeholder]="'Search'"
        ariaLabel="search-menu"
        [searchOptions]="selectionOptions"
      >
        <mat-icon [svgIcon]="'search'" position="prefix"></mat-icon>
      </aw-search>
    </div>

    <app-aw-dropdown-form
      [required]="false"
      [options]="statusOptions()"
      title="Status"
      (currentOption)="onFilterSelected($event)"
    ></app-aw-dropdown-form>

    @if (userPermissions['canEdit']) {
    <Button
      AwButton
      [disable]="disableChangeStatus"
      (click)="openChangeStatusMultipleDialog = true"
      >Change Status</Button
    >

    } @if (userPermissions['canDelete']) {
    <Button
      AwButton
      [disable]="disableDeleteEmployee"
      (click)="openDeleteMultipleEmployeesDialog = true"
      >Delete</Button
    >
    }
    <aw-dialog
      [visible]="openChangeStatusMultipleDialog"
      [formFieldsData]="formFieldsData()"
      [dialogOptions]="dialogOptionsStatus"
      (primaryAction)="dialogFormValuesHandler($event, 'status-multiple')"
      (secondaryAction)="dialogCloseHandler('status-multiple')"
      ariaLabel="Change employees status"
    >
    </aw-dialog>

    <aw-dialog
      [visible]="openChangeStatusSingleDialog"
      [formFieldsData]="formFieldsData()"
      [dialogOptions]="dialogOptionsStatus"
      (primaryAction)="dialogFormValuesHandler($event, 'status-single')"
      (secondaryAction)="dialogCloseHandler('status-single')"
      ariaLabel="Change employee status"
    >
    </aw-dialog>

    <aw-dialog
      [visible]="openDeleteMultipleEmployeesDialog"
      [dialogOptions]="dialogOptionsDelete"
      (primaryAction)="dialogFormValuesHandler($event, 'delete-multiple')"
      (secondaryAction)="dialogCloseHandler('delete-multiple')"
      ariaLabel="Delete employees"
    >
    </aw-dialog>
    <aw-dialog
      [visible]="openDeleteEmployeeDialog"
      [dialogOptions]="dialogOptionsDelete"
      (primaryAction)="dialogFormValuesHandler($event, 'delete-single')"
      (secondaryAction)="dialogCloseHandler('delete-single')"
      ariaLabel="Delete employee"
    >
    </aw-dialog>
  </div>

  <aw-table
    [columnsDefinition]="columnsDefinition"
    [tableData]="tableData()"
    [enableStickyOptions]="enableStickyOptions()"
    [optionsMenu]="optionsMenu"
    [sortDisabled]="sortDisabled()"
    (checkboxList)="checkBoxActionHandler($event)"
    (optionsMenuClicked)="handleActionMenu($event)"
  >
  </aw-table>
</div>

@if (userPermissions['canCreate']) {
<div class="footer-container">
  <aw-action-bar [actionsRight]="actionsRight()"> </aw-action-bar>
</div>
}
